import { useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import styles from "../Styles/loginPage.module.css";
import { Button, Paper, Typography, Grid } from "@mui/material";
import { postData } from "../Services/postData";
import { localUrlEnum, endpoints } from "../Utils/UrlEnum";
import { useNavigate } from "react-router-dom";
import { Vocabulary } from "../Utils/Vocabulary";
import { ForgotPasswordModel } from "../Utils/Models";
import { HttpStatusCode } from "../Utils/Constants";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [resetData, setResetData] = useState<ForgotPasswordModel>(
    new ForgotPasswordModel()
  );
  const [errorText, setErrorText] = useState("");
  const [successText, setSuccessText] = useState("");

  /**
   *
   */
  const handleSubmit = async () => {
    try {
      localStorage.clear();
      const url = endpoints.forgotPassword;
      const response = await postData(url, resetData);
      if (response && response?.data && response?.data?.code) {
        setSuccessText(Vocabulary.resetInProgress);
        setErrorText("");
      } else {
        setErrorText(Vocabulary.loginValidationError);
        setSuccessText("");
      }
    } catch (err: any) {
      if (err.response && err.response.status === HttpStatusCode.Unauthorized) {
        setErrorText(Vocabulary.loginValidationError);
        setSuccessText("");
      } else if (err.message) {
        console.error(err);
        setErrorText(err.message);
        setSuccessText("");
      }
    }
  };

  /**
   *
   * @param event
   */
  const onChangeTextField = (event: any) => {
    const newUser: any = Object.assign({}, resetData);
    newUser[event.target.name] = event.target.value;
    setResetData(newUser);
  };

  return (
    <div className={styles.App}>
      <div className={styles.blurOverlay} />
      <Paper className={styles.loginContainer} elevation={5}>
        <Grid container spacing={1} className={styles.gridMainContainer}>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className={styles.firstGrid}
          >
            <img
              src={"/sigur-la-volan-no-background.png"}
              alt="SigurLaVolan"
              width={"100%"}
            />
            <ValidatorForm className={styles.form} onSubmit={handleSubmit}>
              <TextValidator
                variant="standard"
                id="username"
                name="username"
                fullWidth
                label="Username"
                validators={["required"]}
                type="email"
                errorMessages={[
                  Vocabulary.requiredField,
                  Vocabulary.emailValidation,
                ]}
                value={resetData.username}
                onChange={(e) => onChangeTextField(e)}
                className={styles.textfield}
              />
              <Button
                variant="contained"
                type="submit"
                className={styles.submit}
              >
                {Vocabulary.resetPassword}
              </Button>
              <Typography className={styles.errorText}>{errorText}</Typography>
              {successText && (
                <Typography className={styles.reset}>{successText}</Typography>
              )}

              <Button
                variant="outlined"
                type="reset"
                color="secondary"
                className={styles.reset}
                onClick={() => navigate(localUrlEnum.login)}
              >
                {Vocabulary.back}
              </Button>
            </ValidatorForm>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
}
